import { SVGAttributes } from "react";

export const GitHubSocialLogo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M24 0V24H0V0H24Z" fill="white" fillOpacity="0.01" />
      <path
        d="M12 2C17.525 2 22 6.475 22 12C21.9995 14.0953 21.3419 16.1376 20.1198 17.8395C18.8977 19.5415 17.1727 20.8173 15.1875 21.4875C14.6875 21.5875 14.5 21.275 14.5 21.0125C14.5 20.675 14.5125 19.6 14.5125 18.2625C14.5125 17.325 14.2 16.725 13.8375 16.4125C16.0625 16.1625 18.4 15.3125 18.4 11.475C18.4 10.375 18.0125 9.4875 17.375 8.7875C17.475 8.5375 17.825 7.5125 17.275 6.1375C17.275 6.1375 16.4375 5.8625 14.525 7.1625C13.725 6.9375 12.875 6.825 12.025 6.825C11.175 6.825 10.325 6.9375 9.525 7.1625C7.6125 5.875 6.775 6.1375 6.775 6.1375C6.225 7.5125 6.575 8.5375 6.675 8.7875C6.0375 9.4875 5.65 10.3875 5.65 11.475C5.65 15.3 7.975 16.1625 10.2 16.4125C9.9125 16.6625 9.65 17.1 9.5625 17.75C8.9875 18.0125 7.55 18.4375 6.65 16.925C6.4625 16.625 5.9 15.8875 5.1125 15.9C4.275 15.9125 4.775 16.375 5.125 16.5625C5.55 16.8 6.0375 17.6875 6.15 17.975C6.35 18.5375 7 19.6125 9.5125 19.15C9.5125 19.9875 9.525 20.775 9.525 21.0125C9.525 21.275 9.3375 21.575 8.8375 21.4875C6.8458 20.8245 5.11342 19.5513 3.88611 17.8483C2.65881 16.1453 1.9989 14.0991 2 12C2 6.475 6.475 2 12 2Z"
        fill="var(--g-color-text-primary)"
      />
    </svg>
  );
};
